import React from "react";
import { useTranslation } from "react-i18next";
import { ReportIcon } from "@common/reportIcon";
import { Props } from "./types";
import { IndicatorsList } from "./indicatorsList";
import styles from "./styles.scss";

function Report({ report, indicatorsNames }: Props) {
  const { t } = useTranslation();
  const reportName =
    report.name.length <= 60 ? report.name : report.name.slice(0, 60) + "...";

  return (
    <div className={styles.report}>
      <div className={styles.headerItem}>
        <div className={styles.author}>
          <ReportIcon className={styles.reportIcon} />
          <div>
            <p className={styles.name}>{reportName}</p>
            <p className={styles.authorName}>
              {t("projectPage.synthesisPage.reports.by")} {report.author} -{" "}
              {new Date(report.submissionDate).toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>
      <div className={styles.headerItem}>
        <div className={styles.indicators}>
          <IndicatorsList
            indicators={report.fields.filter(
              ({ type }) => type === "indicator",
            )}
          />
        </div>
      </div>
    </div>
  );
}

export { Report };
